import NoResultsBanner from './NoResultsBanner.vue'

export default NoResultsBanner
